import groq from 'groq';
import { SanityKeyed, ProductCollection } from '../../schemaTypes';
import type { FagmoblerAlgoliaProduct } from '@fagmobler/types';

export type MaterializedProductCollectionBlock = SanityKeyed<
  ProductCollection & {
    products?: FagmoblerAlgoliaProduct[];
  }
>;

export const productCollectionProjection = groq`
  ...
`;
